import { z } from 'zod';
import { SUPPLIER_LOYALTY_CODE, uniqueCodes } from './loyalty_codes';

/** Teto da lista de programas de locadora por viajante — o mesmo das listas aérea e
 *  de hotel. */
export const RENTAL_LOYALTY_PROGRAMS_MAX = 20;

/**
 * Programa de fidelidade de LOCADORA do viajante (spec 2026-10-08). Como o de hotel,
 * vive num store do customer-api (`rental_loyalty_programs`): o legado não tem o
 * campo — a mesma exceção sancionada em "Profile truth". `vendorCode` é o `codes[0]`
 * do catálogo: o código de locadora na Sabre (2 chars, `ZE` = Hertz) ou a chave
 * própria (3–12 chars) de quem não está no GDS, que nunca vai para ela
 * (`isSabreChainCode`); `vendorName` é o `owner` do catálogo, para a leitura não
 * depender dele; `number` só `trim` — pode ser o CPF, quando a locadora identifica o
 * membro por ele.
 */
export const RentalLoyaltyProgramSchema = z
  .object({
    vendorCode: z.string().regex(SUPPLIER_LOYALTY_CODE),
    vendorName: z.string().min(1).max(80),
    number: z.string().trim().min(1).max(40),
  })
  .strict();
export type RentalLoyaltyProgram = z.infer<typeof RentalLoyaltyProgramSchema>;

/** Wire de leitura E de escrita (`PUT` substitui a lista inteira). */
export const RentalLoyaltyProgramsSchema = z
  .object({
    programs: z
      .array(RentalLoyaltyProgramSchema)
      .max(RENTAL_LOYALTY_PROGRAMS_MAX)
      .superRefine(uniqueCodes((row) => row.vendorCode, 'vendorCode')),
  })
  .strict();
export type RentalLoyaltyPrograms = z.infer<typeof RentalLoyaltyProgramsSchema>;
